/* ============================================================
   <mega-nav> — controlador do mega menu desktop.
   - Abertura "com intencao": atraso ao entrar, area segura ao
     sair (delay de fechamento) e troca instantanea entre itens
     ja com o menu aberto.
   - Scrim movido para o <body> e header elevado acima dele
     enquanto algum painel esta aberto.
   - Suporte a teclado (foco + Esc) e a movimento reduzido.
   O CSS abre via :hover como fallback ate este JS marcar
   o root como .mega--ready.
   ============================================================ */
(function () {
  'use strict';

  var OPEN_DELAY = 120;
  var CLOSE_DELAY = 220;

  class MegaNav extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice
        .call(this.querySelectorAll('[data-mega-item]'))
        .filter(function (li) {
          return li.querySelector('[data-mega-panel]');
        });
      if (!this.items.length) return;

      this.scrim = this.querySelector('[data-mega-scrim]');
      this.sectionEl = this.closest('.shopify-section') || null;
      this.current = null;
      this._openT = null;
      this._closeT = null;
      this._savedZ = '';
      this._savedPos = '';

      // Move o scrim para o body para escapar do contexto de empilhamento do header
      if (this.scrim && this.scrim.parentNode !== document.body) {
        document.body.appendChild(this.scrim);
      }

      var self = this;
      this.items.forEach(function (li) {
        li.addEventListener('mouseenter', function () {
          self._onEnter(li);
        });
        li.addEventListener('mouseleave', function () {
          self._onLeave();
        });
        li.addEventListener('focusin', function () {
          self._open(li);
        });
        li.addEventListener('focusout', function (e) {
          if (!li.contains(e.relatedTarget)) self._scheduleClose();
        });
      });

      this.addEventListener('mouseleave', function () {
        self._onLeave();
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.current) {
          var c = self.current;
          self._closeAll();
          var top = c.querySelector('.mega__top');
          if (top) top.focus();
        }
      });

      // Pronto: desliga o fallback de :hover puro do CSS
      this.classList.add('mega--ready');
    }

    _onEnter(li) {
      clearTimeout(this._closeT);
      if (this.current && this.current !== li) {
        this._open(li); // troca instantanea com o menu ja aberto
        return;
      }
      clearTimeout(this._openT);
      var self = this;
      this._openT = setTimeout(function () {
        self._open(li);
      }, OPEN_DELAY);
    }

    _onLeave() {
      clearTimeout(this._openT);
      this._scheduleClose();
    }

    _scheduleClose() {
      clearTimeout(this._closeT);
      var self = this;
      this._closeT = setTimeout(function () {
        self._closeAll();
      }, CLOSE_DELAY);
    }

    _open(li) {
      clearTimeout(this._openT);
      clearTimeout(this._closeT);
      if (this.current === li) return;
      this._alignPanels();
      if (!this._onResize) {
        this._onResize = this._alignPanels.bind(this);
        window.addEventListener('resize', this._onResize);
      }
      if (this.current) this._setState(this.current, false);
      this._setState(li, true);
      this.current = li;
      this._activate(true);
      this._loadProducts(li);
    }

    // Painéis são full-bleed: alinha a borda esquerda e a largura à janela,
    // independente da largura/posição do contêiner pai.
    _alignPanels() {
      var rect = this.getBoundingClientRect();
      this.style.setProperty('--mega-x', -rect.left + 'px');
      this.style.setProperty('--mega-w', document.documentElement.clientWidth + 'px');
    }

    // Painel de produtos "mais vendidos" carregado sob demanda (Section Rendering
    // API). Renderiza no contexto da colecao com ?sort_by=best-selling.
    _loadProducts(li) {
      var grid = li.querySelector('[data-mega-products]');
      if (!grid || grid.dataset.loaded === '1' || grid.dataset.loading === '1') return;
      var url = grid.getAttribute('data-collection-url');
      if (!url) return;

      MegaNav._prodCache = MegaNav._prodCache || {};
      var cache = MegaNav._prodCache;

      var apply = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.mega__prod');
        if (fresh) {
          grid.innerHTML = fresh.innerHTML;
          grid.classList.remove('mega__prod--pending');
          grid.dataset.loaded = '1';
        } else {
          grid.dataset.loading = '';
        }
      };

      if (cache[url]) {
        apply(cache[url]);
        return;
      }

      grid.dataset.loading = '1';
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'sort_by=best-selling&section_id=mega-produtos', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          cache[url] = html;
          apply(html);
        })
        .catch(function () {
          // Em caso de falha, remove o skeleton e deixa so o "Ver todos" (link da colecao).
          grid.dataset.loading = '';
          grid.classList.remove('mega__prod--pending');
          grid.innerHTML =
            '<a class="mega__prod-card mega__prod-card--all" href="' + url + '">' +
            '<span class="mega__prod-all-text">Ver todos</span></a>';
        });
    }

    _closeAll() {
      clearTimeout(this._openT);
      clearTimeout(this._closeT);
      if (this.current) this._setState(this.current, false);
      this.current = null;
      this._activate(false);
    }

    _setState(li, open) {
      li.classList.toggle('is-open', open);
      var top = li.querySelector('.mega__top');
      if (top) top.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    _activate(on) {
      if (this.scrim) this.scrim.classList.toggle('is-active', on);
      var el = this.sectionEl;
      if (!el) return;
      if (on) {
        this._savedZ = el.style.zIndex;
        this._savedPos = el.style.position;
        // So' forca 'relative' se a secao for realmente static. Ela e' sticky
        // (via CSS), entao trocar para relative quebraria a fixacao e faria o
        // header "pular" p/ o topo do documento com a pagina rolada — causando
        // o piscar (abre/fecha em loop). Sticky ja' cria contexto de empilhamento,
        // entao o z-index sozinho basta p/ ficar acima do scrim.
        if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
        el.style.zIndex = '60';
      } else {
        el.style.zIndex = this._savedZ;
        el.style.position = this._savedPos;
      }
    }
  }

  if (!customElements.get('mega-nav')) {
    customElements.define('mega-nav', MegaNav);
  }

  // ---- Drawer mobile: paginacao ----
  // O bundle nao atualiza o data-modal-id do botao "Voltar" no mobile, entao
  // tratamos aqui: "Voltar" fecha o submenu aberto mais profundo (volta 1 nivel);
  // fechar o drawer (X / overlay) reseta tudo p/ reabrir na raiz.
  function closeDropdown(dd) {
    if (!dd) return;
    if (typeof dd.close === 'function') dd.close();
    else dd.classList.remove('open');
  }
  document.addEventListener('click', function (e) {
    var back = e.target.closest('.mdh__back, .header__menu-back--arrow');
    if (back) {
      var open = document.querySelectorAll('.header__menu-modal .menu-link-list__dropdown.open');
      if (open.length) {
        e.preventDefault();
        closeDropdown(open[open.length - 1]);
      }
      return;
    }
    if (e.target.closest('.header__menu-close, .header__menu-close-overlay')) {
      document
        .querySelectorAll('.header__menu-modal .menu-link-list__dropdown.open')
        .forEach(closeDropdown);
      return;
    }
    // Ao abrir uma sub-pagina, zera o scroll do nav p/ o painel (inset:0) alinhar.
    if (e.target.closest('.menu-link-list__item--dropdown .menu-link-list__item-link-wrapper')) {
      var nav = document.querySelector('.header__menu-modal .header__menu-modal-nav');
      if (nav) requestAnimationFrame(function () { nav.scrollTop = 0; });
    }
  });

  // ---- Saudacao por horario no CTA de conta (cliente logado) ----
  // Usa a hora LOCAL do usuario (evita timezone/cache do Liquid).
  (function () {
    var el = document.querySelector('.mdh__greeting-hi[data-greeting]');
    if (!el) return;
    var h = new Date().getHours();
    var greeting = h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
    var name = (el.getAttribute('data-name') || '').trim().split(/\s+/)[0] || '';
    el.textContent = name ? greeting + ', ' + name : greeting;
  })();
})();
